import React, { useEffect } from "react";
import { FunctionComponent } from "react";
import { createBrowserRouter, useLocation } from "react-router-dom"; 
import MainLayout from "./layouts/mainLayout";
import ChangeLogPage from "./pages/changeLogPage";
import ErrorPage from "./pages/errorPage";
import FeaturesPage from "./pages/featuresPage";
import MainPage from "./pages/mainPage";
import PrivacyPolicyPage from "./pages/privacyPolicyPage";
import TermsPage from "./pages/termsPage";

const router = createBrowserRouter([
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                index: true,
                element: <MainPage />
            },
            {
                path: "privacyPolicy",
                element: <PrivacyPolicyPage />
            },
            {
                path: "changeLog",
                element: <ChangeLogPage />
            },
            {
                path: "termsAndConditions",
                element: <TermsPage />
            },
            {
                path: "features",
                element: <FeaturesPage />
            },
        ]
    },
    {
        path: "*",
        element: <ErrorPage />
    }
]);

export const ScrollToTop: FunctionComponent = () => {
    const { pathname } = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  
    return null;
}


export default router;